import { QuickActionType } from '@src/components/QuickActionItem/QuickActionType';
import React, { memo } from 'react';
import TemplatePurposeIcon from '../TemplatePurposeIcon';
import * as Styled from './QuickActionItem.styles';

export type Props = {
	item: QuickActionType;
	isSelected: boolean;
	itemProps: {};
};

const QuickActionItem: React.FC<Props> = ({ item, isSelected, itemProps }) => {
	return (
		<Styled.Container $isSelected={isSelected} {...itemProps}>
			<div>
				{item.templateName ? <TemplatePurposeIcon name={item.templateName}/> : item.isStatic ? (
					<Styled.StaticCommandIcon />
				) : (
					<Styled.DynamicCommandIcon />
				)}
				<Styled.Command $isStatic={item.isStatic && !item.templateName} className="bold">
					{item.displayName ?? (item.isStatic ? item.command : item.command.substring(1))}
				</Styled.Command>{' '}
				{!item.displayName && <>{item.parameterHint} {item.parameters?.join(' ')}</>}
			</div>
			{!item.templateName && item.description && <Styled.Description>{item.description}</Styled.Description>}
		</Styled.Container>
	);
};

export default memo(QuickActionItem);
